<template>
  <div>
    <form-wizard
      color="#ce7b2c"
      :title="null"
      :subtitle="null"
      :finish-button-text="$t('site.finish')"
      :back-button-text="$t('site.back')"
      :next-button-text="$t('site.next')"
      @on-complete="formSubmitted"
    >
      <b-card>
        <!-- edu-courses tab -->
        <tab-content
          :title="$t('edu_programs.assign_teachers')"
          :before-change="() => validateStep('edu_courses')"
        >
          <b-tabs v-model="tab">
            <b-tab
              :title="$t('edu_programs.assign_teachers')"
              active
              @click="getEduCourses"
            >
              <assign-teachers-vue ref="teachers" />
            </b-tab>
            <b-tab
              @click="newItem = { account_type: 'teacher' }"
              :title="$t('site.add')"
            >
              <users-form :new-item="newItem" />
            </b-tab>
          </b-tabs>
        </tab-content>
        <!-- edu-courses tab -->

        <!-- edu_seasons tab -->
        <tab-content
          :title="$t('edu_seasons.edu_seasons')"
          :before-change="() => validateStep('edu_seasons')"
        >
          <b-tabs v-model="tab">
            <b-tab
              :title="$t('edu_seasons.edu_seasons')"
              active
              @click="getEduSeasons"
            >
              <b-col>
                <b-form-group>
                  <v-select
                    dir="rtl"
                    v-model="data.edu_season_id"
                    :options="edu_seasons"
                    :reduce="(item) => item.id"
                    label="name"
                  />
                </b-form-group>
              </b-col>
            </b-tab>
            <b-tab @click="newItem = {}" :title="$t('site.add')">
              <edu-seasons-form
                :new-item="newItem"
                :wizard="true"
                ref="seasons"
              />
            </b-tab>
          </b-tabs>
        </tab-content>
        <!-- edu_seasons tab -->
        <!-- program_lists tab -->
        <tab-content
          :title="$t('program_lists.program_lists')"
          :before-change="() => validateStep('program_lists')"
        >
          <b-tabs v-model="tab">
            <b-tab
              :title="$t('program_lists.program_lists')"
              active
              @click="getProgramLists"
            >
              <b-col>
                <b-form-group>
                  <v-select
                    dir="rtl"
                    v-model="data.program_list_id"
                    :options="program_lists"
                    :reduce="(item) => item.id"
                    :before-change="() => validateStep('program_lists')"
                    label="name"
                  />
                </b-form-group>
              </b-col>
            </b-tab>
            <b-tab @click="newItem = {}" :title="$t('site.add')">
              <program-lists-form
                :new-item="{}"
                :wizard="true"
                ref="programLists"
              />
            </b-tab>
          </b-tabs>
        </tab-content>
        <!-- program_lists tab -->
        <!-- edu_programstab -->
        <tab-content
          :title="$t('edu_programs.edu_programs')"
          :before-change="() => validateStep('edu_programs')"
        >
          <edu-programs-form
            :new-item="{
              program_list_id: data.program_list_id,
              edu_season_id: data.edu_season_id,
            }"
            :wizard="true"
            ref="programs"
          />
        </tab-content>
        <!-- edu_programs tab -->
        <!-- edu-courses tab -->
        <tab-content
          :title="$t('edu_courses.edu_courses')"
          :before-change="() => validateStep('edu_courses')"
        >
          <b-tabs v-model="tab">
            <b-tab
              :title="$t('edu_courses.edu_courses')"
              active
              @click="getEduCourses"
            >
              <assign-courses-vue :edu-program="program" ref="edu_courses" />
            </b-tab>
            <b-tab @click="newItem = {}" :title="$t('site.add')">
              <edu-courses-form :new-item="newItem" />
            </b-tab>
          </b-tabs>
        </tab-content>
        <!-- edu-courses tab -->
      </b-card>
    </form-wizard>
  </div>
</template>

<script>
import Edu_seasonsController from "@/Controllers/Edu_seasonsController";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Edu_seasonsVue from "../Edu_seasons/components/Form.vue";
import vSelect from "vue-select";
import Program_listsVue from "../Program_lists/components/Form.vue";
import Program_listsController from "@/Controllers/Program_listsController";
import Edu_programsForm from "./components/Form.vue";
import Edu_coursesVue from "../Edu_courses/components/Form.vue";
import AssignCoursesVue from "./components/AssignCourses.vue";
import AssignTeachersVue from "./components/AssignTeachers.vue";
import UsersVue from "../Users/components/Form.vue";
export default {
  components: {
    FormWizard,
    TabContent,
    vSelect,
    "edu-seasons-form": Edu_seasonsVue,
    "program-lists-form": Program_listsVue,
    "edu-programs-form": Edu_programsForm,
    "edu-courses-form": Edu_coursesVue,
    "users-form": UsersVue,

    AssignCoursesVue,
    AssignTeachersVue,
  },
  data() {
    return {
      tab: 0,
      newItem: {},
      data: {},
      edu_seasons: [],
      program_lists: [],
      edu_courses: [],
      program: {},
    };
  },
  created() {
    this.getEduSeasons();
    this.getProgramLists();
  },
  methods: {
    async validateStep(name) {
      if (name == "edu_seasons") {
        let season = await this.$refs.seasons.getSeason();
        this.data.edu_season_id = season.id;
        return this.data.edu_season_id != null;
      }
      if (name == "program_lists") {
        let programLists = await this.$refs.programLists.getProgramLists();
        this.data.program_list_id = programLists.id;

        return this.data.program_list_id != null;
      }
      if (name == "edu_programs") {
        let program = await this.$refs.programs.getProgram();
        this.$set(this, "program", program);
        return this.program.id != null;
      }
      if (name == "edu_courses") {
        let res = this.$refs.edu_courses.returnData();
        if (res) {
          this.$refs.teachers.getData(this.program.id);
        }
        return res;
      }
      //
    },
    formSubmitted() {
      this.$router.push({ name: "EduPrograms" });
    },
    getEduSeasons() {
      new Edu_seasonsController().GetAll().then((res) => {
        this.edu_seasons = res;
      });
    },
    //
    getProgramLists() {
      new Program_listsController().GetAll().then((res) => {
        this.program_lists = res;
      });
    },
    getEduCourses() {
      this.$refs.edu_courses.getData();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>